import React__default from 'react';
import { CircularProgress, Skeleton } from '@mui/material';
import clsx from 'clsx';
import KButton from '../../KButtons/index.js';
import StyledKModalAction, { classes } from './index.styled.js';

var KModalAction = function (_a) {
    var onClick = _a.onClick, className = _a.className, loading = _a.loading, title = _a.title, children = _a.children, _b = _a.testId, testId = _b === void 0 ? "KModalAction" : _b, id = _a.id, _c = _a.alt, alt = _c === void 0 ? false : _c, sx = _a.sx, isLoading = _a.isLoading;
    return (React__default.createElement(StyledKModalAction, { id: id, className: clsx("KModalAction", className), alt: alt, sx: sx },
        React__default.createElement(KButton, { testId: testId, className: clsx(classes.button, alt && classes.buttonAlt, "KModalAction-KButton", alt && "KModalAction-KButton-alt"), size: "large", color: "primary", variant: alt ? "outlined" : "contained", onClick: onClick, disabled: isLoading },
            loading && React__default.createElement(CircularProgress, { size: "1rem", className: classes.loading }),
            isLoading && React__default.createElement(Skeleton, { animation: "wave", width: 150 }),
            !isLoading && (title || children))));
};

export { KModalAction as default };
//# sourceMappingURL=index.js.map
